module.exports = __webpack_public_path__ + "img/EALT_Logo.298d288d.png";